import * as Config from '../../../../../config';
import React from 'react';
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import Content from '../../../common/Content';
import SubMenu from '../../../common/SubMenu';
import ListV2 from '../../../content/list/ListV2';
import ListColumns from '../../../content/list/ListColumns';
import TrendsV2 from '../../../trends/TrendsV2';
import FooterV2 from '../../../views/FooterV2';
// import RadioButton from '../../../automix/RadioButton';
import AutomixStandAloneButton from '../../../automix/AutomixStandAloneButton';

import usePageScroll from '../../../../../hooks/usePageScroll';

function ConnectedDiscoverManager({ dimension }) {
  const { width, height } = dimension;
  let { url } = useRouteMatch();
  let { onScroll } = usePageScroll();

  return (
    <>
      <div className={`discover-page`} style={{ height }} onScroll={onScroll}>
        <Content name={`Discover`} isSticky={true} 
          stickyClassName={`sticky-menu-discover`}
          contentClassName={`content-discover`}
          styleHeader={{width: width + (Config.CONTENT_PAD * 2)}}
          subContent={(
            <div className='flexRow'>
              <div className={`flexRow slider-menu global-menu`}>
                <SubMenu to={`/home/trending`} or={`${url}`} label={`Trending`} />
                <SubMenu to={`/home/top-100`} label={`Global Top 100`} />
                <SubMenu to={`/home/hype-100`} label={`Hype Top 100`} />
              </div>
              {/* {<RadioButton className={'discover-radio-button'} />} */}
            </div>
          )}
        >
          <Switch>
            <Route exact path={[`/`, `/home`, `/home/trending`]}>
              <div id={`onboarding-start`} style={{ position: `relative`}}>
                <ListColumns
                  title={'Global Top 10'}
                  pathApi={`/catalog/tracks/top/100/?enabled=true&is_hype=false`}
                  linkToUID={'Global Top 100'}
                  id={`{A}listC-top100`}
                  width={width}
                  height={(Config.LIST_ROW_HEIGHT * 5)}
                  size={Config.LIST_ROW_HEIGHT}
                  columnCount={2}
                  rowCount={5}
                  rowType={`Column`}
                  hasPagination={false} allTo={`/top-100`} allLabel={`View Top 100`}
                  enableArrows={true}
                  style={{marginTop: -20}}
                />
              </div>
              <AutomixStandAloneButton pathApi={`/catalog/tracks/top/100/?enabled=true&per_page=100`} uid={`Global Top 100`} from={`/home/top-100`} className={`discover-automix-button`} isShow={true} />
              <ListColumns
                title={'Hype Top 10'}
                pathApi={`/catalog/tracks/top/100/?enabled=true&is_hype=true`}
                id={`{B}listC-top100`}
                width={width}
                height={(Config.LIST_ROW_HEIGHT * 5)}
                size={Config.LIST_ROW_HEIGHT}
                columnCount={2}
                rowCount={5}
                rowType={`Column`}
                hasPagination={false} allTo={`/hype-100`} allLabel={`View Hype 100`}
                enableArrows={true}
              />
              <TrendsV2
                pathApi={`/catalog/tracks/top/100/?enabled=true&per_page=100`}
                width={width}
                params={[ 
                  {
                    id: `global-artists`, type: 'artists', title: `Trending Artists`, props: [`artists`, `remixers`], format: `formattedArtist`, isRandom: true, isRanked: false,
                    grid: {
                      rowWidth: 135, //112
                      rowHeight: 165, //145,
                      rowPadding: 4,
                      coverBorder: 4,
                      gap: 8,
                      hasPagination: true,
                      blockClassName: 'card-artist',
                      coverClassName: 'cover-artist',
                    }
                  },{
                    id: `global-labels`, type: 'labels', title: `Trending Labels`, props: [`release|label`], format: `formattedLabel`, isRandom: true, isRanked: false,
                    grid: {
                      rowWidth: 135, //112,
                      rowHeight: 168, //158 //138,
                      rowPadding: 8,
                      coverBorder: 0,
                      gap: 8,
                      hasPagination: true,
                      blockClassName: 'card-label',
                      coverClassName: 'cover-label',
                    }
                  }, 
                  {
                    id: `global-genres`, type: 'genres', title: `Trending Genres`, props: [`genre`], format: `formattedGenre`, isRandom: false, isRanked: true, limit: 20,
                    forceData: [
                      { 'id':  11, 'name': "Tech House", 'rank': 1, 'slug': "tech-house", 'to': "/genres/tech-house/featured", 'type': "GENRE", 'vote': 20},
                      { 'id':  5, 'name': "House", 'rank': 2, 'slug': "house", 'to': "/genres/house/featured", 'type': "GENRE", 'vote': 19},
                      { 'id':  6, 'name': "Techno (Peak Time / Driving)", 'rank': 3, 'slug': "techno-peak-time-driving", 'to': "/genres/techno-peak-time-driving/featured", 'type': "GENRE", 'vote': 18},
                      { 'id':  90, 'name': "Melodic House & Techno", 'rank': 4, 'slug': "melodic-house-techno", 'to': "/genres/melodic-house-techno/featured", 'type': "GENRE", 'vote': 17},
                      { 'id':  1, 'name': "Drum & Bass", 'rank': 5, 'slug': "drum-bass", 'to': "/genres/drum-bass/featured", 'type': "GENRE", 'vote': 16},
                      { 'id':  39, 'name': "Dance / Electro Pop", 'rank': 6, 'slug': "dance-electro-pop", 'to': "/genres/dance-electro-pop/featured", 'type': "GENRE", 'vote': 15},
                      { 'id':  12, 'name': "Deep House", 'rank': 7, 'slug': "deep-house", 'to': "/genres/deep-house/featured", 'type': "GENRE", 'vote': 14},   
                      { 'id':  89, 'name': "Afro House", 'rank': 8, 'slug': "afro-house", 'to': "/genres/afro-house/featured", 'type': "GENRE", 'vote': 13},
                      { 'id':  14, 'name': "Minimal / Deep Tech", 'rank': 9, 'slug': "minimal-deep-tech", 'to': "/genres/minimal-deep-tech/featured", 'type': "GENRE", 'vote': 12},
                      { 'id':  15, 'name': "Progressive House", 'rank': 10, 'slug': "progressive-house", 'to': "/genres/progressive-house/featured", 'type': "GENRE", 'vote': 11},
                      { 'id':  92, 'name': "Techno (Raw / Deep / Hypnotic)", 'rank': 11, 'slug': "techno-raw-deep-hypnotic", 'to': "/genres/techno-raw-deep-hypnotic/featured", 'type': "GENRE", 'vote': 10},
                      { 'id':  37, 'name': "Indie Dance", 'rank': 12, 'slug': "indie-dance", 'to': "/genres/indie-dance/featured", 'type': "GENRE", 'vote': 9},
                      { 'id':  7, 'name': "Trance (Main Floor)", 'rank': 13, 'slug': "trance-main-floor", 'to': "/genres/trance-main-floor/featured", 'type': "GENRE", 'vote': 8},
                      { 'id':  93, 'name': "Organic House / Downtempo", 'rank': 14, 'slug': "organic-house-downtempo", 'to': "/genres/organic-house-downtempo/featured", 'type': "GENRE", 'vote': 7},
                      { 'id':  2, 'name': "Hard Techno", 'rank': 15, 'slug': "hard-techno", 'to': "/genres/hard-techno/featured", 'type': "GENRE", 'vote': 6},
                      { 'id':  96, 'name': "Mainstage", 'rank': 16, 'slug': "mainstage", 'to': "/genres/mainstage/featured", 'type': "GENRE", 'vote': 5},
                      { 'id':  81, 'name': "Funky House", 'rank': 17, 'slug': "funky-house", 'to': "/genres/funky-house/featured", 'type': "GENRE", 'vote': 4},
                      { 'id':  3, 'name': "Electronica", 'rank': 18, 'slug': "electronica", 'to': "/genres/electronica/featured", 'type': "GENRE", 'vote': 3},
                      { 'id':  50, 'name': "Nu Disco / Disco", 'rank': 19, 'slug': "nu-disco-disco", 'to': "/genres/nu-disco-disco/featured", 'type': "GENRE", 'vote': 2},
                      { 'id':  91, 'name': "Bass House", 'rank': 20, 'slug': "bass-house", 'to': "/genres/bass-house/featured", 'type': "GENRE", 'vote': 1},     
                    ],
                    grid: {
                      rowWidth: 100,
                      rowHeight: 40,
                      gap: 12,
                      hasPagination: false,
                      showAll: true,
                      className: 'grid-list-genres',
                    }
                  }
                ]}
              />
              <FooterV2 />
            </Route>
            <Route exact path={[`/top-100`, `${url}/top-100`]}>
              <ListV2
                titleClassName={'brand-primary'}
                subTitleClassName={'type-light'}
                subTitle={` Top 100`}
                titleContainerClassName={`title-border-bottom`}
                pathApi={`/catalog/tracks/top/100/?enabled=true&is_hype=false&per_page=100`}
                sortable={false}
                id={`top100`}
                width={width}
                height={height - Config.STICKY_HEADER_HEIGHT}
                size={Config.LIST_ROW_HEIGHT}
                style={{marginTop: 85}}
                filtersStyle={{position: `absolute`, top: 23, right: 279}}
                panelStyle={{ margin: `0px 0px 16px 0px` }}
                isLoadMore={false}
                type={`Full#`}
                orderBy={[`release`, `top`, `title`, `mix_name`, `remixers_s`, `label`, `genre_s`, `key_camelot`, `bpm`, `artists_s`]}
                filters={[`track_name`, /*`mix_name`,*/ `artists_s`, `remixers_s`, `label`, `genre_s`, `bpm`, `key`]}
                isBoost={true}
                automix={true}
                automixName={`Global Top 100`}
                automixStyle={{ position: `absolute`, top: 23, left: `auto`, right: 0 }}
                enableShortcuts={true}
                from={`/home/top-100`}
                enableSave={true}
              />
            </Route>
            <Route exact path={[`/hype-100`, `${url}/hype-100`]}>
              <ListV2
                titleClassName={'brand-tertiary'}
                subTitleClassName={'type-light'}
                subTitle={` Hype 100`}
                titleContainerClassName={`title-border-bottom`}
                pathApi={`/catalog/tracks/top/100/?enabled=true&hype=true&per_page=100`}
                sortable={false}
                id={`hype100`}
                width={width}
                height={height - Config.STICKY_HEADER_HEIGHT}
                size={Config.LIST_ROW_HEIGHT}
                style={{marginTop: 85}}
                filtersStyle={{position: `absolute`, top: 23, right: 279}}
                panelStyle={{ margin: `0px 0px 16px 0px` }}
                isLoadMore={false}
                type={`Full#`}
                orderBy={[`release`, `top`, `title`, `mix_name`, `remixers_s`, `label`, `genre_s`, `key_camelot`, `bpm`, `artists_s`]}
                filters={[`track_name`, /*`mix_name`,*/ `artists_s`, `remixers_s`, `label`, `genre_s`, `bpm`, `key`]}
                isBoost={true}
                automix={true}
                automixName={`Hype Top 100`}
                automixStyle={{ position: `absolute`, top: 23, left: `auto`, right: 0 }}
                enableShortcuts={true}
                from={`/home/hype-100`}
                enableSave={true}
              />
            </Route>
          </Switch>
        </Content>
      </div>
    </>
  );
}

ConnectedDiscoverManager.propTypes = {
  dimension: PropTypes.object
}

const DiscoverManager = connect(
  state => ({
    dimension: state.dimension
  })
)(ConnectedDiscoverManager);

export default DiscoverManager;
